/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import TowerBase from "src/views/report/custom/TowerBase.react";
import Yaw from "src/views/report/custom/Yaw.react";
import NacelleSubFrame from "src/views/report/custom/NacelleSubFrame.react";
import Converter from "src/views/report/custom/Converter.react";
import Hub from "src/views/report/custom/Hub.react";
import HubBoard from "src/views/report/custom/HubBoard.react";
import Generator from "src/views/report/custom/Generator.react";
import Blade from "src/views/report/custom/Blade.react";
import TransformerRoom from "src/views/report/custom/TransformerRoom.react";
import Ground from "src/views/report/custom/Ground.react";
import Bolt from "src/views/report/custom/Bolt.react";

/**
 * The Custom component
 *
 * @author Thais Watanabe
 */
const Custom = (props) => {
  const {
    turbineInspection,
    inspectionModel,
    inspectionModelItems,
    results,
    lastResults,
    lastTurbineInspections,
    openEdit,
    openObs,
    inspection,
    print
  } = props;

  return (
    <>
      {inspectionModel.modelNumber === 2 && (
        <TowerBase
          inspection={inspection}
          inspectionModel={inspectionModel.name}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          inspectionModelItems={inspectionModelItems}
          results={results}
          openEdit={openEdit}
          openObs={openObs}
        />
      )}

      {inspectionModel.modelNumber === 3 && (
        <Yaw
          inspection={inspection}
          inspectionModel={inspectionModel.name}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          inspectionModelItems={inspectionModelItems}
          results={results}
          lastResults={lastResults}
          openEdit={openEdit}
          openObs={openObs}
        />
      )}

      {inspectionModel.modelNumber === 4 && (
        <NacelleSubFrame
          inspection={inspection}
          inspectionModel={inspectionModel.name}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          inspectionModelItems={inspectionModelItems}
          results={results}
          lastResults={lastResults}
          openEdit={openEdit}
          openObs={openObs}
        />
      )}

      {inspectionModel.modelNumber === 6 && (
        <Converter
          inspection={inspection}
          inspectionModel={inspectionModel.name}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          inspectionModelItems={inspectionModelItems}
          results={results}
          lastResults={lastResults}
          openEdit={openEdit}
          openObs={openObs}
        />
      )}

      {inspectionModel.modelNumber === 8 && (
        <Hub
          inspection={inspection}
          inspectionModel={inspectionModel.name}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          inspectionModelItems={inspectionModelItems}
          results={results}
          lastResults={lastResults}
          openEdit={openEdit}
          openObs={openObs}
        />
      )}

      {inspectionModel.modelNumber === 9 && (
        <HubBoard
          inspection={inspection}
          inspectionModel={inspectionModel.name}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          inspectionModelItems={inspectionModelItems}
          results={results}
          lastResults={lastResults}
          openEdit={openEdit}
          openObs={openObs}
        />
      )}

      {inspectionModel.modelNumber === 10 && (
        <Generator
          inspection={inspection}
          inspectionModel={inspectionModel.name}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          inspectionModelItems={inspectionModelItems}
          results={results}
          lastResults={lastResults}
          openEdit={openEdit}
          openObs={openObs}
        />
      )}

      {inspectionModel.modelNumber === 11 && (
        <Blade
          inspection={inspection}
          inspectionModel={inspectionModel.name}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          inspectionModelItems={inspectionModelItems}
          results={results}
          lastResults={lastResults}
          openEdit={openEdit}
          openObs={openObs}
        />
      )}

      {inspectionModel.modelNumber === 12 && (
        <TransformerRoom
          inspection={inspection}
          inspectionModel={inspectionModel.name}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          inspectionModelItems={inspectionModelItems}
          results={results}
          lastResults={lastResults}
          openEdit={openEdit}
          openObs={openObs}
        />
      )}

      {inspectionModel.modelNumber === 13 && (
        <Ground
          inspection={inspection}
          inspectionModel={inspectionModel.name}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          inspectionModelItems={inspectionModelItems}
          results={results}
          lastResults={lastResults}
          openEdit={openEdit}
          openObs={openObs}
        />
      )}

      {inspectionModel.modelNumber === 14 && (
        <Bolt
          inspection={inspection}
          inspectionModel={inspectionModel.name}
          turbineInspection={turbineInspection}
          lastTurbineInspections={lastTurbineInspections}
          inspectionModelItems={inspectionModelItems}
          results={results}
          lastResults={lastResults}
          openEdit={openEdit}
          openObs={openObs}
          print={print}
        />
      )}
    </>
  );
};

export default Custom;
